<template>
  <div v-if="loggedShop">
    <h3 class="om-page-heading">
      {{ (!order || !order.collected ) ? $tr('Odbiór zamówienia', 'Order') : $tr('Zwrot zamówienia', 'Order') }}
      <router-link :to="{ name: (this.$route.name == 'Collect' ? 'CollectList' : 'OrderList')}" class="om-link-back">
        <i class="om-ico-back-link" aria-hidden="true"></i>
        {{ $tr('wróć', 'Order') }}
      </router-link>
    </h3>
    <div v-if="order" class="om-order">
      <ul class="om-order__general">
        <li>
          <span class="om-order__lab">{{ $tr('Zamówienie:', 'Order') }}</span> {{ order.reference }}
        </li>
        <li>
          <span class="om-order__lab">{{ $tr('Imię i nazwisko:', 'Order') }}</span> {{ order.firstname + ' ' + order.lastname }}
        </li>
        <li>
          <span class="om-order__lab">{{ $tr('Telefon:', 'Order') }}</span> {{ order.phone }}
        </li>
        <li>
          <span class="om-order__lab">{{ $tr('Adres e-mail:', 'Order') }}</span> {{ order.email }}
        </li>
        <li v-if="order.store_collect && order.store_collect.name">
          <span class="om-order__lab">{{ $tr('Miejsce odbioru:', 'Order') }}</span>
          <div class="om-order__val">
            <div>{{order.store_collect.name}}</div>
            <div v-if="order.store_collect.address">
              <div>{{ $tr('ul.', 'Order') }} {{ order.store_collect.address.street }} {{ order.store_collect.address.flat ? `${order.store_collect.address.house}/${order.store_collect.address.flat}` : `${order.store_collect.address.house}` }}</div>
              <div>{{order.store_collect.address.postcode}} {{order.store_collect.address.city}}</div>
            </div>
          </div>
        </li>
      </ul>

      <div v-if="order.products" class="om-products">
        <table class="om-table">
          <thead>
            <tr>
              <th>{{ $tr('Produkty', 'Order') }} ({{ order.products.length }})</th>
              <th>{{ $tr('Cena jednostkowa (brutto)', 'Order') }}</th>
              <th>{{ $tr('Ilość', 'Order') }}</th>
              <th v-if="order.collected">
                {{ $tr('Ilość zwracanych produktów', 'Order') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p, k) in order.products" :key="k">
              <td>
                <div class="flex cen">
                  <div class="om-products__image">
                    <img :src="p.image" :alt="p.name"/>
                  </div>
                  <div class="om-products__desc fg-20">
                    <h4 class="om-products__medium">{{ p.name }}</h4>
                    <h5 class="om-products__small">{{ $tr('Kod produktu:', 'Order') }} {{ p.reference }}</h5>
                    <ul v-if="p.attributes" class="om-attributes">
                      <li v-for="(a, k) in p.attributes" class="om-products__small" :key="k">
                        {{ k }}: {{ a }}
                      </li>
                    </ul>
                  </div>
                </div>
              </td>
              <td class="om-std">{{ p.price }} <span class="currency">{{ p.currency }}</span></td>
              <td class="om-std">{{ p.quantity }}</td>
              <td class="om-std" v-if="order.collected && p.quantity - p.quantity_returned > 0">
                <input class="om-input--qty" type="text" @keyup.prevent="orderReturnModify($event, p)"/> <span class="om-slash">/</span> {{ p.quantity - p.quantity_returned }}
              </td>
              <td v-else-if="order.collected">
                {{ $tr('zwrócono wszystkie', 'Order') }}
              </td>
            </tr>
          </tbody>

        </table>
      </div>
      <span class="om-vertical-space"></span>

      <div v-if="anyDocumentsAvailable">
        <h3 class="om-subheading">
          {{ $tr('Dokumenty do pobrania:', 'Order') }}
        </h3>
        <div v-if="collectPDFCanBeDisplayed">
          <div class="om-pdf-link__line">
            <button class="om-pdf-link" @click="downloadCollectPDF($event, order.reference)">
              <i class="om-ico-file-pdf-o om-pdf-link__ico" aria-hidden="true"></i>
              {{ $tr(`Potwierdzenie odbioru`, 'Order') }}
            </button>  
          </div>
        </div>

        <div v-if="returnPDFCanBeDisplayed">
          <div class="om-pdf-link__line" v-for="(code, k) in order.returns_pdf" :key="k">
            <button class="om-pdf-link" @click="downloadReturnPDF($event, code)">
              <i class="om-ico-file-pdf-o om-pdf-link__ico" aria-hidden="true"></i>
              {{ $tr(`Potwierdzenie zwrotu `, 'Order') }} {{code}}
            </button>
          </div>
        </div>
        <span class="om-vertical-space"></span>
      </div>
    
      <div v-if="!order.collected" class="om-order-state">
        <div v-if="typeof order.store_collect_details !== 'undefined' && order.store_collect_details.code !== loggedShop.code">
          <h3 class="om-subheading">
            {{ $tr('Zamówienie do odebrania w sklepie:', 'Order') }}
          </h3>
          <div>{{ order.store_collect_details.name }}</div>
          <div>
            {{ $tr('ul.', 'ShopList') }} {{ order.store_collect_details.address.street }}
            {{ order.store_collect_details.address.house }}
            {{ typeof order.store_collect_details.address.flat !== 'undefined' && order.store_collect_details.address.flat !== '' ? `/ ${order.store_collect_details.address.flat}` : '' }}
          </div>
          <div>{{ order.store_collect_details.address.postcode }} {{ order.store_collect_details.address.city }}</div>
        </div>
        <div v-else="">
          <h3 class="om-subheading">
            {{ $tr('Status odbioru', 'Order') }}
          </h3>
          <div class="flex cen">
            <label class="om-dropdown__title">{{ $tr('Zamówienie:', 'Order') }}</label>
            <dropdown
              v-if="states"
              :items="states"
              :default-label="defaultState ? defaultState.name : $tr('Wybierz', 'Order')"
              :default-value="defaultState ? defaultState.value : 0"
              v-on:change="changeChoosedState"></dropdown>
          </div>
          <div class="flex h-cen">
            <button @click.prevent="pushOrderState()" id="cta-push-order-state" class="om-btn om-btn--medium om-btn--update">{{ $tr('Aktualizuj status', 'Order') }}</button>
          </div>
        </div>
        <!--<h3 v-else="" class="om-subheading">
          {{ $tr('Ten sklep nie obsługuje odbiorów', 'Order') }}
        </h3>-->
      </div>
      <div v-else="">
        <div v-if="loggedShop.can_return" class="flex sb wrap">
          <div class="om-col-8">
            <h3 class="om-subheading">
              {{ $tr('Podsumowanie zwrotu:', 'Order') }}
            </h3>
            <ul class="om-summary">
              <li class="flex">
                <div class="om-summary__lab">{{ $tr('Nazwy produktów:', 'Order') }}</div>
                <div class="om-summary__val">
                <span v-for="(prod, i, k) in returnProducts" :key="i">
                  {{ prod.name }}{{ Object.keys(returnProducts).length > k + 1 ? ',' : '' }}
                </span>
                  <span v-if="!Object.keys(returnProducts).length">-</span>
                </div>
              </li>
              <li class="flex wrap">
                <div class="om-summary__lab">{{ $tr('Ilość zwróconych produktów:', 'Order') }}</div>
                <div class="om-summary__val">{{ returnSummary.quantity }}</div>
              </li>
              <li class="flex wrap">
                <div class="om-summary__lab">{{ $tr('Wartość zwróconych produktów:', 'Order') }}</div>
                <div class="om-summary__val">{{ $helper.displayPrice(returnSummary.value, returnSummary.currency) }}</div>
              </li>
            </ul>
          </div>
          <div class="om-col-4">
            <h3 class="om-subheading">
              <label for="message">{{ $tr('Uwagi:', 'Order') }} <span class="om-subheading__small">{{ $tr('(opcjonalnie)', 'Order') }}</span></label>
            </h3>
            <textarea v-model="message" class="om-textarea" name="message" id="message" cols="30" rows="10"></textarea>
          </div>
          <div class="flex h-cen fg-20">
            <button @click.prevent="pushReturn()" id="cta-push-return" class="om-btn om-btn--medium om-btn--update">{{ $tr('Dokonaj zwrotu', 'Order') }}</button>
          </div>
        </div>
        <h3 v-else="" class="om-subheading">
          {{ $tr('Ten sklep nie może dokonywać zwrotów', 'Order') }}
        </h3>
      </div>
      <span class="om-vertical-space"></span>
    </div>
    <div v-else-if="notFound">
      {{ $tr('Brak szczegółów zamówienia', 'Order') }}
    </div>
    <div v-else>
    </div>
  </div>
</template>

<script>
  import Paginator from '../reusable/paginator/Paginator.vue'
  const FileSaver = require('file-saver')
  // PDF debug
  const debug = 0

  export default {
    components: {Paginator},
    name: 'order',
    data () {
      return {
        order: null,
        notFound: false,
        states: null,
        defaultState: null,
        choosedState: null,
        returnProd: {},
        returnProducts: {},
        message: ''
      }
    },
    mounted () {
      if (typeof this.$route.params.reference !== 'undefined') {
        this.$http.get(this.$router.options.getApiRoute('order', {reference: this.$route.params.reference})).then((resp) => {
          if (typeof resp.body[0] !== 'undefined') {
            console.log(resp.body[0])
            this.order = resp.body[0]
            if (this.order.ready_for_collection) {
              this.defaultState = this.states[0]
              this.choosedState = this.states[0].value
            }
          } else {
            this.notFound = true
          }
        },
        (resp) => {
          console.log(resp.body)
          this.notFound = true
        })
      }

      /* status dropdown */
      this.states = [
        {name: this.$tr('Gotowe do odbioru', 'Order'), value: 'ready_to_collect'},
        {name: this.$tr('Odebrane', 'Order'), value: 'collected'}
        /* {name: this.$tr('Nieodebrane', 'Order'), value: 24} */
      ]
      // actions
    },
    methods: {
      changeChoosedState (val, key) {
        this.choosedState = val
      },
      validatePDFResponse (response) {
        if (typeof response.headers.map['content-type'] !== 'undefined') {
          let ct = response.headers.map['content-type']
          ct = ct instanceof Array ? ct.join('') : ct
          if (ct === 'application/json') {
            let error = this.$tr('Wystąpił błąd', 'Order')
            if (typeof response.data === 'object' && response.data.error) {
              error = response.data.error
            }
            this.$alertify.notify(this.$tr(error, 'Order'), 'error', 3)
            return false
          }
        }
        return true
      },
      pdfDebug (response) {
        if (debug) {
          let ifr = document.getElementById('PDF_PREVIEW_IFRAME')
          if (!ifr) {
            ifr = document.createElement('iframe')
            ifr.id = 'PDF_PREVIEW_IFRAME'
            const body = document.getElementsByTagName('body')[0]
            body.appendChild(ifr)
          }
          const factor = 794 / 210
          ifr.width = parseInt(210 * factor)
          ifr.height = parseInt(297 * factor)
          ifr.style.width = '21cm'
          ifr.style.height = '29.7cm'
          ifr.style.margin = '0 auto'
          ifr.style.border = 'none'
          ifr.style.display = 'block'
          let iframeElementContainer = document.getElementById('PDF_PREVIEW_IFRAME').contentDocument
          iframeElementContainer.open()
          iframeElementContainer.write(response.data.html)
          iframeElementContainer.close()
          return
        } else {
          let ifr = document.getElementById('PDF_PREVIEW_IFRAME')
          if (ifr) {
            ifr.remove()
          }
        }
      },
      downloadReturnPDF (ev, code) {
        ev.preventDefault()
        this.$http.post(
          this.$router.options.getApiRoute('order-return-pdf', {code}),
          { debug },
          {
            headers: {
              'Accept': 'application/pdf'
            },
            responseType: debug ? 'json' : 'blob'
          }
        )
          .then((response) => {
            if (!this.validatePDFResponse(response)) {
              return
            }
            this.pdfDebug(response)
            let fileName = 'return.pdf'
            if (typeof response.headers.map['x-filename'] !== 'undefined') {
              fileName = response.headers.map['x-filename']
            }
            FileSaver.saveAs(new Blob([response.body], {type: 'application/pdf;charset=utf-8'}), fileName)
            return response
          })
          .catch((response) => {
            this.$alertify.notify(this.$tr('Wystąpił błąd', 'Order'), 'error', 3)
          })
      },
      downloadCollectPDF (ev, reference) {
        ev.preventDefault()
        this.$http.post(
          this.$router.options.getApiRoute('order-collect-pdf', {reference}),
          { debug },
          {
            headers: {
              'Accept': 'application/pdf'
            },
            responseType: debug ? 'json' : 'blob'
          }
        )
          .then((response) => {
            if (!this.validatePDFResponse(response)) {
              return
            }
            this.pdfDebug(response)
            let fileName = 'return.pdf'
            if (typeof response.headers.map['x-filename'] !== 'undefined') {
              fileName = response.headers.map['x-filename']
            }
            FileSaver.saveAs(new Blob([response.body], {type: 'application/pdf;charset=utf-8'}), fileName)
            return response
          })
          .catch((response) => {
            this.$alertify.notify(this.$tr('Wystąpił błąd', 'Order'), 'error', 3)
          })
      },
      pushOrderState () {
        if (!this.choosedState) {
          this.$alertify.notify(this.$tr('Wybierz status do aktualizacji', 'Order'), 'warning', 3)
          return false
        }
        if (this.choosedState === 'ready_to_collect' && this.order.ready_for_collection) {
          this.$alertify.notify(this.$tr('Zamówienie zostało już oznaczone jako gotowe do odebrania. Zaznacz inny status.', 'Order'), 'error', 3)
          return false
        }
        if (this.choosedState === 'collected' && this.order.ready_for_collection === 0) {
          this.$alertify.notify(this.$tr('Zamówienie nie zostało jeszcze oznaczone jako gotowe do odebrania.', 'Order'), 'error', 3)
          return false
        }
        this.$http.post(this.$router.options.getApiRoute('order', {reference: this.$route.params.reference}), {
          state: this.choosedState
        }).then((resp) => {
          if (resp.ok) {
            this.$alertify.notify(this.$tr('Zaktualizowano status zamówienia', 'Order'), 'success', 3)
            this.$router.push({name: 'OrderList'})
          }
        },
        (resp) => {
          console.log('fail:')
          console.log(resp)
          this.$helper.stdErrors(resp)
          if (typeof resp.body === 'object' && resp.body.message) {
            this.$alertify.notify(resp.body.message, 'error', 3)
          }
        })
      },
      pushReturn () {
        this.$http.post(this.$router.options.getApiRoute('order-return', {reference: this.$route.params.reference}), {
          products: this.returnProducts,
          summary: this.returnSummary,
          message: this.message
        }).then((resp) => {
          console.log(resp.body)
          if (resp.ok) {
            this.$router.push({name: 'OrderList'})
          }
        },
        (resp) => {
          console.log('fail:')
          console.log(resp)
          this.$helper.stdErrors(resp)
        })
      },
      orderReturnModify (event, product) {
        console.log(product)
        let val = Number(event.target.value)
        if (isNaN(val) && event.target.value !== '') {
          event.target.value = 0
          val = 0
        }
        if (val > (product.quantity - product.quantity_returned)) {
          event.target.value = product.quantity - product.quantity_returned
          val = product.quantity - product.quantity_returned
        }
        this.modifyReturnModify(val, product)
        event.target.value = val
      },
      modifyReturnModify (val, product) {
        if (val === 0) {
          delete this.returnProd[product.reference]
        } else {
          this.returnProd[product.reference] = {
            name: product.name,
            quantity: val,
            price: product.price,
            currency: product.currency
          }
        }
        this.returnProducts = {}
        this.returnProducts = this.returnProd
      }
    },
    computed: {
      anyDocumentsAvailable () {
        return this.returnPDFCanBeDisplayed || this.collectPDFCanBeDisplayed
      },
      returnSummary () {
        let sum = 0
        let qty = 0
        let currency = ''
        for (let prod in this.returnProducts) {
          console.log(prod)
          sum += this.returnProducts[prod].price * this.returnProducts[prod].quantity
          qty += this.returnProducts[prod].quantity
          currency = this.returnProducts[prod].currency
        }
        return {
          value: sum.toFixed(2),
          currency: currency,
          quantity: qty
        }
      },
      loggedShop () {
        return this.$store.getters.getShop
      },
      collectPDFCanBeDisplayed () {
        return (this.order.ready_for_collection || this.order.collected || this.order.state === 'Gotowe do odbioru') && !(this.order.returns_pdf && this.order.returns_pdf.length)
      },
      returnPDFCanBeDisplayed () {
        return this.order.returns_pdf && this.order.returns_pdf.length
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../../assets/scss/settings";
  @import "../../assets/scss/utilities";

  .om-order{
    &__lab{
      text-align: right;
      display: inline-block;
      width: 185px;
      padding-right: 45px;
      max-width: 50%;
      color: $omni-color-order-lab;
      font-family: $omni-font-custom;
      font-size: 16px;
      font-weight: 600;
      font-variant: small-caps;
    }
    &__val{
      display: inline-block;
      vertical-align: top;
    }
    &__general{
      list-style: none;
      margin: 50px 0 9px;
      padding: 0;
      li{
        line-height: 20px;
        color: $omni-color-table;
        font-size: 15px;
        font-weight: 700;
        padding: 0 0 8px;
      }
    }
    .om-table{
      th{
        color: $omni-color-table-head;
        background-color: transparent;
        border-bottom: 1px solid $omni-color-table-head;
        &:first-of-type{
          text-transform: uppercase;
        }
      }
      td{
        &.om{
          color: $omni-color-dark;
          font-size: 16px;
          font-weight: 400;
          line-height: 18px;
          text-transform: uppercase;
        }
        // &.product{
        // }
      }
      tr:nth-of-type(2n+1) td {
        background-color: transparent;
      }
    }
  }

  .om-slash{
    text-align: center;
    width: 20px;
    display: inline-block;
  }

  .om-input--qty{
    width: 43px;
    height: 40px;
    border: 1px solid #c3c3c3;
    background-color: #ffffff;
    line-height: 38px;
    text-align: center;
    &:focus{
      outline: none;
      box-shadow: none;
    }
  }

  .om-products{
    margin: 60px 0 20px;
    padding: 15px 36px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    background-color: #eff3f6;
    &__medium{
      color: $omni-color-dark;
      font-family: $omni-font-family;
      font-size: 16px;
      font-weight: 400;
      line-height: 18px;
      margin: 0 0 3px;
      padding: 0;
    }
    &__small{
      color: $omni-color-dark;
      font-family: $omni-font-family;
      font-size: 13px;
      font-weight: 300;
      line-height: 18px;
      margin: 0;
      padding: 0;
    }
    &__desc{
      padding-left: 11px;
    }
    &__image{
      width: 74px;
    }
  }

  .om-dropdown__title{
    padding: 0 25px 0 0;
    color: $omni-color-dark;
    font-family: $omni-font-family;
    font-size: 11px;
    font-weight: 400;
    line-height: 27px;
    text-transform: uppercase;
  }

  .om-btn--update{
    margin: 30px 0 15px;
    width: 326px;
    max-width: 100%;
  }
  .om-attributes{
    list-style: none;
    padding: 0;
    margin: 0;
    li{
      margin: 0;
      padding: 0;
    }
  }
  .om-col-8{
    width: 2px / 3px * 100%;
  }
  .om-col-4{
    width: 1px / 3px * 100%;
  }
  .om-col-4, .om-col-8{
    @include sm{
      width: 100%;
    }
  }
  .om-textarea{
    width: 100%;
    height: 69px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    border: 1px solid #c3c3c3;
    background-color: #ffffff;
    resize: vertical;
    padding: 5px 10px;
    font-family: $omni-font-family;
    font-size: 14px;
    font-weight: 300;
  }
  .om-summary{
    list-style: none;
    padding: 0;
    margin: 0;
    &__lab{
      width: 224px;
      padding-right: 25px;
      color: #69727e;
      font-family: $omni-font-custom;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      font-variant: small-caps;
      text-align: right;
    }
    &__val{
      color: $omni-color-table;
      font-family: $omni-font-family;
      font-size: 15px;
      font-weight: 700;
      line-height: 20px;
      max-width: calc(100% - 224px);
    }
    li{
      padding: 0 0 8px;
      margin: 0;
    }
  }
  .om-pdf-link{
    cursor: pointer;
    color: #313942;
    font-family: "Josefin Sans", sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    text-transform: uppercase;
    text-decoration: none;
    &__line{
      display: block;
      margin: 4px 0;
    }
    &__ico{
      margin-right: 4px;
      font-size: 20px;
      vertical-align: -3px;
      color: #7792a3;
    }
    &:hover &__ico{
      color: #1999cd;
    }
  }
</style>



// WEBPACK FOOTER //
// Order.vue?1a1e3b85